export var BusinessTaxIdValidationFactory = (function() {
    /* Public Functions */

    var getValidationUtil = function(countryCode) {
        switch (countryCode) {
        case 'IS': {
            return isValidator();
        }
        case 'CO': {
            return coValidator();
        }
        case 'NO': {
            return noValidator();
        }
        case 'AR': {
            return arValidator();
        }
        case 'MX': {
            return mxValidator();
        }
        case 'AU': {
            return auValidator();
        }
        case 'FR': {
            return frValidator();
        }
        case 'NZ': {
            return nzValidator();
        }
        case 'ZA': {
            return zaValidator();
        }
        case 'VN': {
            return vnValidator();
        }
        case 'ID': {
            return idValidator();
        }
        case 'AT': {
            return atValidator();
        }
        case 'DE': {
            return deValidator();
        }
        case 'DK': {
            return dkValidator();
        }
        case 'ES': {
            return esValidator();
        }
        case 'FI': {
            return fiValidator();
        }
        case 'GB': {
            return gbValidator();
        }
        case 'IE': {
            return ieValidator();
        }
        case 'IT': {
            return itValidator();
        }
        case 'NL': {
            return nlValidator();
        }
        case 'PT': {
            return ptValidator();
        }
        case 'SE': {
            return seValidator();
        }
        case 'PF': {
            return pfValidator();
        }
        default: {
            return defaultValidator();
        }
        }
    };

    var defaultValidator = function() {
        var isValidTaxId = function(taxId) {
            return true;
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var isValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 6) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var coValidator = function() {
        var isValidTaxId = function(nit) {
            if (nit && nit.length === 8) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var noValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 9) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var arValidator = function() {
        var isValidTaxId = function(cuit) {
            if (cuit && cuit.length === 12) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var mxValidator = function() {
        var isValidTaxId = function(fdrn) {
            return true;
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var auValidator = function() {
        var isValidTaxId = function(abn) {
            if (!abn || abn.length != 11) {
                return false;
            }

            abn = String(parseInt(abn, 10) - 10000000000);

            var weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
            var sum = 0;

            for (var i=10; i >= 0; i--) {
                sum += parseInt(abn.charAt(i), 10) * weights[i];
            }
            return sum % 89 === 0;
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var frValidator = function() {
        var isValidTaxId = function(siret) {
            if (siret && siret.length === 14) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var nzValidator = function() {
        var isValidTaxId = function(gst) {
            if (gst && gst.length === 9) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var zaValidator = function() {
        var isValidTaxId = function(itn) {
            if (itn && itn.length === 10) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var vnValidator = function() {
        var isValidTaxId = function(tc) {
            if (tc && tc.length === 10) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var idValidator = function() {
        var isValidTaxId = function(npwp) {
            if (npwp && npwp.length === 15) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var atValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 8) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var deValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 9) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var dkValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 8) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var esValidator = function() {
        var isValidTaxId = function(iva) {
            if (iva && iva.length === 9) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var fiValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 8) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };
    // Validation borrowed from http://www.braemoor.co.uk/software/vat.shtml
    // Valid VAT for testing 132710255 or 216528709
    var gbValidator = function() {
        var isValidTaxId = function(vatnumber) {
            var vatRegex = /^(\d{9})$/;
            // Check the string against the regular expressions
            var valid = false;
            if (vatRegex.test(vatnumber)) {
                // Checks the check digits of a UK VAT number.
                var multipliers = [8, 7, 6, 5, 4, 3, 2];
                // Standard and commercial numbers
                var total = 0;
                // Check range is OK for modulus 97 calculation
                var no = Number(vatnumber.slice(0, 7));
                // Extract the next digit and multiply by the counter.
                for (var i = 0; i < 7; i++) {
                    total += Number(vatnumber.charAt(i)) * multipliers[i];
                }
                // Old numbers use a simple 97 modulus, but new numbers use an adaptation of that (less 55). Our
                // VAT number could use either system, so we check it against both.
                // Establish check digits by subtracting 97 from total until negative.
                var cd = total;
                while (cd > 0) {
                    cd = cd - 97;
                }
                // Get the absolute value and compare it with the last two characters of the VAT number. If the
                // same, then it is a valid traditional check digit. However, even then the number must fit within
                // certain specified ranges.
                cd = Math.abs(cd);
                if ((cd == vatnumber.slice(7, 9)) && (no < 9990001 && (no < 100000 || no > 999999))
                    && (no < 9490001 || no > 9700000)) {
                    valid = true;
                } else {
                    // Now try the new method by subtracting 55 from the check digit if we can - else add 42
                    if (cd >= 55) {
                        cd = cd - 55;
                    } else {
                        cd = cd + 42;
                    }
                    if ((cd == vatnumber.slice(7, 9)) && no > 1000000) {
                        valid = true;
                    } else {
                        valid = false;
                    }
                }
            }
            return valid;
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var ieValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 8) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var itValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 11) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var nlValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 12) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var ptValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 9) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var seValidator = function() {
        var isValidTaxId = function(vat) {
            if (vat && vat.length === 12) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    var pfValidator = function() {
        var isValidTaxId = function(tahiti) {
            if (tahiti && tahiti.length === 6) {
                return true;
            } else {
                return false;
            }
        };
        return {
            isValidTaxId: isValidTaxId
        };
    };

    return {
        getValidationUtil: getValidationUtil
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/tax-id/business-tax-id-validation.js
// module id = 339
// module chunks = 0